import { Button, Notification } from '@sorrem-client/ui/components';
import { describeDefeatItemLoss, PARTY_WIPE_SUMMARY } from '@sorrem-client/game/defeat-item-loss-message';
import { useLeaveRun } from '@sorrem-client/ui/features/PlayPage/use-leave-run';
import type { PlayerExpelledPayload } from '@sorrem/shared';
import styles from './ExpelledOverlay.module.scss';

interface ExpelledOverlayProps {
    expelled: PlayerExpelledPayload;
}

/**
 * Shown once the Crucible has cast the local player out after they fell.
 * Dropping out fails the run for them (#255), so it tells them what a
 * party wipe would have: what was forfeited, what the Veil took, and what
 * the run cost.
 */
export function ExpelledOverlay({ expelled }: ExpelledOverlayProps): JSX.Element {
    const leaveRun = useLeaveRun();

    return (
        <Notification title="Cast out" message="The Crucible sets you down outside. The run goes on without you.">
            <div className={styles.expelled}>
                <p className={styles.line}>
                    {PARTY_WIPE_SUMMARY} {describeDefeatItemLoss(expelled.carriedItemLoss ?? undefined)}
                </p>
                {expelled.bankedEssenceSpent > 0 && (
                    <p className={styles.line}>This run cost you {expelled.bankedEssenceSpent} banked essence.</p>
                )}
                <Button onClick={() => { void leaveRun('home'); }}>Return to your character</Button>
            </div>
        </Notification>
    );
}
